import React from "react";
import {
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useTheme } from "@mui/material/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";

const About = () => {
  const theme = useTheme();
  const history = useHistory();
  const isSmallScreen = useMediaQuery("(max-width:768px)");

  const items = [
    { label: "Terms of Use", url: "https://app.mhome.ai/terms-of-use" },
    { label: "Privacy Policy", url: "https://app.mhome.ai/privacy-policy" },
    { label: "Licenses", url: "https://app.mhome.ai/licenses" },
  ];

  return (
    <Box
      display="flex"
      justifyContent="start"
      alignItems="start"
      flexDirection="column"
      height="100%"
      p={2}
      width="100%"
    >
      <Box
        position="static"
        sx={{
          display: "flex",
          alignItems: "center",
          justfyContent: "flex-start",
          mb: 2,
        }}
      >
        {isSmallScreen && (
          <IconButton
            color="inherit"
            edge="start"
            sx={{ mr: 1 }}
            onClick={() => history.replace("/setting")}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        <Box sx={{ display: "flex" }}>
          <Typography variant="h6" style={{ textAlign: "center" }}>
            About
          </Typography>
        </Box>
      </Box>

      <Box display="flex" flexDirection="column" gap={1} width="100%">
        <Card
          sx={{
            width: "100%",
            backgroundColor: "background.paper",
            borderRadius: "8px",
            boxShadow: "none",
          }}
        >
          <CardContent>
            <Box display="flex" flexDirection="column" gap={1}>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontWeight: 500,
                  mb: 0.5,
                }}
              >
                Legal Information
              </Typography>

              <List>
                {items.map((item, index) => (
                  <ListItem
                    key={index}
                    component="a"
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      textDecoration: "none",
                      color: "text.primary",
                      cursor: "pointer",
                      borderRadius: "4px",
                      "&:hover": {
                        backgroundColor: "action.hover",
                      },
                    }}
                  >
                    <ListItemText primary={item.label} />
                    <ListItemIcon sx={{ minWidth: "auto" }}>
                      <ChevronRightIcon />
                    </ListItemIcon>
                  </ListItem>
                ))}
              </List>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default About;
